import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EntradaInserirRoutingModule } from "./entrada-inserir-routing.module";
import { EntradaInserirComponent } from "./entrada-inserir.component";

import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { HttpClientModule } from "@angular/common/http";
import { TableModule } from 'primeng/table';
import { TooltipModule } from "primeng/tooltip";
import { DividerModule } from "primeng/divider";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from "@angular/forms";
import { InputMaskModule } from 'primeng/inputmask';
import { MessagesModule } from 'primeng/messages';
import {CheckboxModule} from 'primeng/checkbox';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from "primeng/inputnumber";
import { DialogModule } from "primeng/dialog";
import {OverlayPanelModule} from 'primeng/overlaypanel';
import { ProgressSpinnerModule } from "primeng/progressspinner";




@NgModule({
    imports: [
        CommonModule,            
        FormsModule,
        EntradaInserirRoutingModule,
        HttpClientModule,        
        ButtonModule,
        InputTextModule,
        TooltipModule,
        DividerModule,
        DropdownModule,
        InputTextareaModule,
        InputMaskModule,
        MessagesModule,
        TableModule,
        CalendarModule,
        InputNumberModule,
        DialogModule,
        OverlayPanelModule,
        ProgressSpinnerModule
    ],
    declarations: [EntradaInserirComponent]
})
export class EntradaInserirModule { }
